import React from "react";
import { Icon } from "~assets/frontend/elements/icon/Icon";
import { getId } from "~assets/frontend/_util/getId";
export const NavigationItemExternal = (props) => {
    return (React.createElement("a", { className: "group/link flex py-12 hocus:text-red-100", href: props.href || "#", target: "_blank" },
        props.title,
        React.createElement(Icon, { _id: getId(), _name: "IconStruct", identifier: "icon-external-link", className: `before:bg-black-40 group-hover/link:before:bg-red-100` })));
};
